import { PiniaColada } from "@pinia/colada";
import { createD3Chart } from "@soft-db/d3-chart";
import { initI18n } from "@soft-db/form";
import { createSoftUI } from "@soft-db/ui";
import { createApp } from "vue";
import App from "./App.vue";
import "./constants";
import { __DEV__, __STAGING__ } from "./constants";
import "./index.css";
import { firebase, googleMaps, http, i18n, monitoringApi, pinia, sentry } from "./plugins";
import { publicPage } from "./plugins/public-page";
import router from "./router";

initI18n();

const app = createApp(App);

app
	// Must be first
	.use(pinia)
	.use(router)
	.use(publicPage)
	.use(firebase)
	.use(PiniaColada, {
		queryOptions: {
			staleTime: 60 * 5_000,
		},
	})
	.use(monitoringApi)
	.use(googleMaps)
	.use(sentry)
	.use(i18n)
	.use(http)
	.use(createSoftUI(), { global: true })
	.use(createD3Chart());

app.config.globalProperties.__DEV__ = __DEV__;
app.config.globalProperties.__STAGING__ = __STAGING__;

declare module "vue" {
	interface ComponentCustomProperties {
		__DEV__: boolean;
		__STAGING__: boolean;
	}
}

app.mount("#app");
